import { ApiInstance } from '@src/services/api-instance';
import { AliareV1Service } from './modules/v1/aliare-middleware-api-v1';

export class AliareMiddlewareApi {
  private readonly client: ApiInstance;

  public v1: AliareV1Service;

  constructor(client?: ApiInstance) {
    const base = '/api-org-config';
    this.client = client || new ApiInstance(base, 30000);

    this.v1 = new AliareV1Service(this.client);
  }
}
